/* eslint-disable */
import BreadCrumb from 'components/BreadCrumb';
import React,{ useEffect, useState, useRef } from 'react';
import { useLocation, useHistory } from "react-router-dom";
import ButtonV2 from 'components/ButtonV2';
import ButtonNoBorder from 'components/ButtonNoBorder';
import ButtonSecondary from 'components/ButtonSecondary';
import DropdownV3 from 'components/DropdownV3';
import { dataCategory,listLanguage, opsiHeader, opsiButton, TypeCTA, TypeQuickReply, UrlTypeCTA, categoryTemplate } from 'containers/NewWaTemplate/ListDropdownData';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'
import _ from 'lodash';
import Modal from "react-modal";
import { Alert, AlertType } from "utils/Alert";

import { listDomain } from 'utils/listDomain';

// Library
import FeatherIcon from 'feather-icons-react';

// components
import PhoneMediaPreview from "./PhoneMediaPreview"

// services
import applicationSvc from "services/applicationSvc";
import waTemplateSvc from "services/waTemplateSvc";

// style
import './FormCreateTemplate.scss';
import '../whatsappTemplate.scss';
import styled from "styled-components";

// image
import AlertTriangle from '_assets/svg/alert-triangle.svg';
import InputDropdown from 'components/InputDropdown';
import ConfirmModalSubmit from '../ConfirmModalSubmit';
import FormAuthentication from './FormAuthentication/index';
import BadgeInfo from './BadgeInfo';
import AddButtonTemplate from './AddButtonTemplate';
import ContentTemplate from './ContentTemplate';
import { forBody, forButton, forFooter, forHeader } from 'utils/dataTemplate';
// import SampleContent from './SampleContent';

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "40vw",
  },
};

function FormCreateTeamplate() {
  const location = useLocation();
  const [isListAccount, setListAccount] = useState([])
  const [isSelectedAccount, setSelectedAccount] = useState({value:'', name:''})
  const history = useHistory();
  const [dropdownButtons, setDropdownButtons] = useState(false);
  const [isOptionMedia, setOptionMedia] = useState({name: '', value: ''});
  const [isOptionButtons, setOptionButtons] = useState({name: '', value: ''});
  const [isOptionPhoneNumber, setOptionPhoneNumber] = useState({name: '', value: '', img:''});
  const [isTemplate_name, setTemplate_name] = useState("");
  const [isPreview, setPreview] = useState({});
  const [isHeaderPhone, setHeaderPhone] = useState({ type: "", text: "", body: "" });
  const [isHeaderPreview, setHeaderPreview] = useState({ type: "none", text: "", body: "" });
  const [isBodyTemplate, setBodyTemplate] = useState("");
  const [isMessage, setMessage] = useState("");
  const [isPrefButton, setPrefButton] = useState([]);
  const [isCountVariable, setCountVariable] = useState(1);
  const [isErrorTemplateName, setErrorTemplateName] = useState(false);
  const [isErrorButtonText, setErrorButtonText] = useState(false);
  const [isOpenModal, setOpenModal] = useState(false);
  const [isDataPost, setDataPost] = useState(null);
  const [isApplicatoinId, setApplicationId] = useState([]);
  const [isOpenModalSubmit, setOpenModalSubmit] = useState({show:false, payload: [], wabaID: '', templateID:'', isChooseTypeTemplate: []});
  const [isTypeQuickReply, setTypeQuickReply] = useState({value:'', name:''});
  const [isTypecta, setTypeCTA] = useState({value:'', name:''});
  const [isURLType, setURLType] = useState({value:'', name:''});
  const [isChooseTypeTemplate, setChooseTypeTemplate] = useState([]);
  const [isSelectedLanguage, setSelectedLanguage] = useState([]);
  const [isSelectNewLanguage, setSelectNewLanguage] = useState({name:'', value:''});
  const [isFooterMessage, setFooterMessage] = useState({type:'', text:''});
  const [isDisableInputHeader, setDisableInputHeader] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [isIndexPage, setIndexPage] = useState(0);
  const [isAddSampleContent, showAddSampleContent] = useState({show: false, isIndexPage: isIndexPage});
  const [listPhoneNumber, setListPhoneNumber] = useState([]);
  const [isDataWabaID, setDataWabaID] = useState();
  const [isVarDynamicWeb] = useState('{{1}}');
  const [isErrorUrl, setErrorUrl] = useState(false);
  const [timer, setTimer] = useState(null)
  const [isDataForAuthentication, setDataForAuthentication] = useState(null)
  const [dataFromLocation, setDataFromLocation] = useState(location?.state?.dataChooseTypeTemplate)
  const [errorValidation, setErrorValidation] = useState('')
  
  const [isBreadcrumb, setBreadCrumb] = useState(
    [
      {
        name: 'WhatsApp Template List',
        link: '/new-whatsapp-template',
      },
      {
        name: 'Form Create Template WhatsApp',
        link: '',
      },
    ]
  );

  // UseRef
  const useRefButtons = useRef();
  useRefButtons.current = isPrefButton;
  
  const useRefHeaderPhone = useRef();
  useRefHeaderPhone.current = isHeaderPhone;
  const isOptionMediaRef = useRef();
  isOptionMediaRef.current = isOptionMedia;

  useEffect(()=>{
    // GET PHONE NUMBER
    let countries = require('country-data').countries
    countries?.all.forEach((item) =>{
      const data = {
        name: item.name,
        label: item.alpha2 + ' ' + item.countryCallingCodes[0],
        value: item.alpha2,
        type: item.countryCallingCodes[0]
      }
      listPhoneNumber.push(data)
      setListPhoneNumber(listPhoneNumber)
    })

    // setDataFromLocation(location?.state?.dataChooseTypeTemplate);
 
    console.log('locations edit',  dataFromLocation)
    if(dataFromLocation?.category?.value === "authentication"){
      setDataForAuthentication(dataFromLocation)
      setListAccount(categoryTemplate)
      // setLisLanguage(listLanguage)
      setSelectedAccount(dataFromLocation?.category)
      setChooseTypeTemplate([dataFromLocation])
      setTemplate_name(dataFromLocation?.templateName)
      setDataWabaID(dataFromLocation?.wabaID)
  
      if(dataFromLocation?.language?.length > 0){
        setSelectedLanguage(dataFromLocation?.language[0]);
      }
    }else{
      if(dataFromLocation?.edit){
  
        // edit bredcrumbd
        isBreadcrumb[1].name = 'Form Edit Template'
        setBreadCrumb(isBreadcrumb)
       
        // mechanism looping data page for edit template
        let dataStructure = dataFromLocation;
       
        const dataS = {
          category: '',
          header: [],
          body:[],
          footer: [],
          buttons: [],
          name: '',
          language: ''
        }
  
        if(dataStructure?.header){
          let dataHeader = dataStructure.header
            dataS.header = 
              [{
                type: dataHeader.type,
                format: dataHeader.type === 'text' ? 'TEXT' : dataHeader.type === 'image' ? 'IMAGE' : dataHeader.type === 'video' ? 'VIDEO' : 'NONE',
                text: dataHeader?.text?.body ? dataHeader?.text?.body : '',
              }]
  
            // console.log('dataHeader', dataHeader)
            if(dataHeader.type === 'text' && dataHeader.type !== 'none'){
              setOptionMedia({
                name: "Text",
                value: "TEXT",
              })
  
              dataS.header[0].text = dataHeader?.text?.body ? dataHeader?.text?.body : dataHeader.text
              
              if(dataHeader?.example?.header_text?.length > 0){
                dataS.header[0].example = {}
  
                dataS.header[0].example.header_text = dataHeader.example.header_text
  
                let indexedMessage = []
  
                if(dataHeader.text?.length >= 2){
                  indexedMessage = [
                    dataHeader.text[dataHeader.text?.length - 2],
                    dataHeader.text[dataHeader.text?.length - 1],
                  ]
                }
                
                const regexp = /{{([0-9]+)}}/gm
                
                const regexpDel = /([0-9])/gm
            
                const matched = dataHeader.text?.match(regexp)
            
                const newVariable = matched?.length > 0 ?  matched?.length + 1 : 1
            
            
                // ADD FUNCTION
                if(indexedMessage[0] == '{' && indexedMessage[1] == '{'){
                  dataHeader.text += `${newVariable}}} `
                  dataHeader.text += `${newVariable}}} `
                }  
            
                // // DELETE FUNCTION
                if(indexedMessage[0]?.match(regexpDel) && indexedMessage[1] == '}'){
                  dataHeader.text = dataHeader.text?.replace('{{'+indexedMessage[0]+'}', '')
                  dataHeader.text = dataHeader.text?.replace('{{'+indexedMessage[0]+'}', '')
                }  
        
                const newMatched = dataHeader.text.match(regexp)
  
                const matchVariable = dataHeader?.example?.header_text[0] || []
            
                dataS.header[0].variable = newMatched?.length > 0 ? newMatched.map((item, idx) => {
                  return {name: item, value: matchVariable || ''}
                }) : []
               
              }
              // else{
              //   dataS.header[0].example.header_text =  []
              // }
            }else if(dataHeader.type !== 'text' && dataHeader.type !== 'none'){
              setOptionMedia({
                  name: "Media",
                  value: "MEDIA"
              })
            
              dataS.header[0].label = 'media'
              if(dataHeader?.example?.header_handle?.length> 0){
                dataS.header[0].example = {}
                dataS.header[0].example.header_handle =  dataHeader.example.header_handle
              }
              // else{
              //   dataS.header[0].example.header_handle = []
              // }
            }
        }else {
          dataS.header = forHeader;
        }
        if(dataStructure?.body){
          // let dataBody = dataStructure?.body;
          const dataBody = decodeURIComponent(dataStructure?.body);
          dataS.body = 
          [{
            type:"text",
            format:"BODY",
            text: dataBody,
            example: {
              body_text: []
            }
          }]
  
  
          if(dataBody?.example?.body_text?.length>0 || dataBody?.text?.match(/([0-9]+)/gm)){
            dataS.body[0].example.body_text = dataBody?.example?.body_text
  
            let indexedMessage = []
  
            if(dataBody.text?.length >= 2){
              indexedMessage = [
                dataBody.text[dataBody.text?.length - 2],
                dataBody.text[dataBody.text?.length - 1],
              ]
            }
            
            const regexp = /([0-9]+)/gm
            
            const regexpDel = /([0-9])/gm
        
            const matched = dataBody.text?.match(regexp)
        
            const newVariable = matched?.length > 0 ?  matched?.length + 1 : 1
        
        
            // ADD FUNCTION
            if(indexedMessage[0] == '{' && indexedMessage[1] == '{'){
              dataBody.text += `${newVariable}}} `
              dataBody.text += `${newVariable}}} `
            }  
        
            // // DELETE FUNCTION
            if(indexedMessage[0]?.match(regexpDel) && indexedMessage[1] == ']'){
              dataBody.text = dataBody.text?.replace('['+indexedMessage[0]+']', '')
              dataBody.text = dataBody.text?.replace('['+indexedMessage[0]+']', '')
            }  
    
            const newMatched = dataBody.text.match(regexp)
  
            const matchVariable = dataBody?.example?.body_text[0] || []
        
            dataS.body[0].variable = newMatched?.length > 0 ? newMatched.map((item, idx) => {
              return {name: item, value: matchVariable[idx] || ''}
            }) : []
            
            // console.log(newMatched, matchVariable, dataBody?.example?.body_text[0], dataS.body,'RESPONSE MATCH DATA')
          }
        }else {
          dataS.body = forBody;
        }
        if(dataStructure?.footer){
          let dataFooter = dataStructure?.footer;
          dataS.footer = 
          [{
            type: "text",
            format: "FOOTER",
            text: dataFooter?.text?.body ? dataFooter.text.body : ''
          }]
         
        }else {
          dataS.footer = forFooter
        }
        if(dataStructure?.button){
          forButton[0].buttons = []
          forButton[1].buttons = []
          let dataButton = dataStructure?.button;
          console.log('dataButton', dataButton)
          dataS.buttons = forButton;
  
          if(dataButton.length>0 && dataButton[0].type !== "copy_code"){
            dataButton.forEach((item) =>{
              if(item.type === 'QUICK_REPLY' || item.type === 'quick_reply' || item.type === 'marketing_disapproval'){
                let data = {
                  type: 'QUICK_REPLY',
                  text: item.text,
                  typeCTA: {name: 'Custom', value: 'custom'}
                }

                if(item.type === 'marketing_disapproval'){
                  data.type = 'marketing_disapproval';
                  data.typeCTA = {name:'Marketing Disapproval', value:'marketing_disapproval'}
                  data.term_condition= item.button_info.term_condition,
                  data.footer_marketing_disapproval= item.button_info.footer_marketing_disapproval || ''
                  setOptionButtons({name:'Marketing Disapproval', value:'marketing_disapproval'})
                }else{
                  setOptionButtons({name: 'Quick Reply', value: 'quick_reply'});
                }

                if(item.order === 0){
                  dataS.buttons[1].buttonType = 'CTA'
                }
                if(item.order === 1){
                  dataS.buttons[0].buttonType = 'CTA'
                }
               
                dataS.buttons[item.order].buttonType = 'QUICK_REPLY'
                dataS.buttons[item.order].buttons.push(data)


              }else{
                let tempData = {
                  type: item.type,
                  text: item.text ? item?.text : item?.button_info.button_text
                }
  
                if(item.type === 'PHONE_NUMBER' || item.type === 'phone_number' || item.type === 'call_phone_number'){
                  tempData.typeCTA = {name: 'Call phone number', value: 'call_phone_number'}
                  // tempData.selectedPhoneNumber = {
                  //   label: item.phone_number, 
                  //   name: item.phone_number, 
                  //   value: item.phone_number,
                  //   type: item?.button_info?.type ? item?.button_info?.type : '',
                  //   value: item?.button_info?.value ? item?.button_info?.value : ''
                  // }
  
                  tempData.phone_number = item.phone_number;
  
                  if(listPhoneNumber){
                    listPhoneNumber.forEach((value) => {
                      if(item?.button_info?.type){
                        if(value.type === item?.button_info?.type){
                          let tempSlice = item?.button_info?.type.length;
                          tempData.selectedPhoneNumber.label = item?.button_info?.type;
                          tempData.selectedPhoneNumber.type = item?.button_info?.type;
                          tempData.phone_number = item?.phone_number?.slice(tempSlice);
                        }
                      }
                      // if(value?.type?.substring(0, 3) === item?.phone_number?.substring(0, 3)){
                      //   let tempSlice = item?.phone_number?.substring(0, 3).length;
                      //   tempData.selectedPhoneNumber.label = item?.phone_number?.substring(0, 3);
                      //   tempData.selectedPhoneNumber.type = item?.phone_number?.substring(0, 3);
                      //   tempData.phone_number = item?.phone_number?.slice(tempSlice);
                      // }
                    })
                  }
                }
                if(item?.type === 'URL' || item?.type === 'url' || item?.type === 'static' || item?.type === 'url_dynamic'){
                  tempData.typeCTA = {name: 'Visit Web', value: 'visit_web'}
                  dataS.buttons[0].action = 'visit_web'
                  tempData.url = item.url ? item.url : item?.button_info?.url
                  tempData.websiteUrl = item.url ? item.url : item?.button_info.url
                  tempData.button_index = item.button_index ? item.button_index : null
                  tempData.sampleUrl = item.sampleUrl ? item.sampleUrl : item?.button_info.sampleUrl
                  
  
                  if(item?.example?.length>0 || item?.type === 'url_dynamic'){
                    tempData.urlType = {name: 'Dynamic', value:'url_dynamic'}
                    tempData.example = item.example
                  }else if(item?.type === 'static' || item?.type === 'url'){
                    tempData.urlType = {name: 'Static', value:'static'}
                    tempData.example = []
                  }
                  // dataS.buttons[0].url = item?.url
                }

                if(item?.type === 'copy_promo_code'){
                  tempData.typeCTA = {name:'Copy Promo Code', value:'copy_promo_code'}
                  tempData.copy_promo_code = item.button_info.copy_promo_code;
                }

                if(item.order === 0){
                  dataS.buttons[1].buttonType = 'QUICK_REPLY'
                }
                if(item.order === 1){
                  dataS.buttons[0].buttonType = 'QUICK_REPLY'
                }
  
                setOptionButtons({name: 'Call To Action', value: 'call_to_action'});
                dataS.buttons[item.order].buttonType = 'CTA'
                dataS.buttons[item.order].buttons.push(tempData)
              }
            })
          }
        }else {
          dataS.buttons = forButton;
        }
        dataStructure.dataStructure = dataS;
  
        setListAccount(categoryTemplate)
        // setLisLanguage(listLanguage)
        setSelectedAccount({
          name: 
          dataFromLocation?.template_category === 'MARKETING' ? 'Marketing' : 
          dataFromLocation?.template_category === 'AUTHENTICATION' ? 'Authentication' :
          dataFromLocation?.template_category === 'UTILITY' ? 'Utility' : '',
          value:dataFromLocation?.template_category
        })
        setChooseTypeTemplate([dataFromLocation])
        setTemplate_name(dataFromLocation?.template_name)
        setDataWabaID(dataFromLocation?.waba_id)
    
        listLanguage.forEach((langData) => {
          if(langData.value === dataFromLocation?.language){
            setSelectedLanguage({
              name: langData.name,
              value: dataFromLocation?.language,
            });
          }
        })
     
      }
      if(!dataFromLocation?.edit){
        forHeader[0].text = ''
        forBody[0].text = ''
        forFooter[0].text = ''
        forButton[0].buttons = []
        forButton[1].buttons = []
        // mechanism looping data page for create template
        let dataStructure = dataFromLocation?.language;
        dataStructure.forEach((item, index) =>{
          const dataS = {
            category: '',
            header: forHeader,
            body: forBody,
            footer: forFooter,
            buttons: forButton,
            name: '',
            language: ''
          }
          return dataStructure[index].dataStructure = dataS;
        })
     
        setListAccount(categoryTemplate)
        // setLisLanguage(listLanguage)
        setSelectedAccount(dataFromLocation?.category)
        setChooseTypeTemplate(dataFromLocation?.language)
        setTemplate_name(dataFromLocation?.templateName)
        setDataWabaID(dataFromLocation?.wabaID)
    
        if(dataFromLocation?.language?.length > 0){
          setSelectedLanguage(dataFromLocation?.language[0]);
        }
      }
    }
  }, [location])

  function addNewTemplate(){
    // mechanism looping data page for create template
    let dataStructure = dataFromLocation?.language;
    dataStructure.forEach((item, index) =>{
      const dataS = {
        category: '',
        header: forHeader,
        body: forBody,
        footer: forFooter,
        buttons: forButton,
        name: '',
        language: ''
      }
      return dataStructure[index].dataStructure = dataS;
    })
 
    setListAccount(categoryTemplate)
    // setLisLanguage(listLanguage)
    setSelectedAccount(dataFromLocation?.category)
    setChooseTypeTemplate(dataFromLocation?.language)
    setTemplate_name(dataFromLocation?.templateName)
    setDataWabaID(dataFromLocation?.wabaID)

    if(dataFromLocation?.language?.length > 0){
      setSelectedLanguage(dataFromLocation?.language[0]);
    }
  }
  useEffect(() => {
    
    setPreview({
      button: useRefButtons.current.length > 0 ? useRefButtons.current : [],
      header: isHeaderPreview,
      footer: isFooterMessage,
      message: isMessage.trim(),
    });
 
    if(isBodyTemplate.length === 0){
      setCountVariable(1)
    }
  }, [isBodyTemplate, isHeaderPhone, useRefButtons.current, isOptionMedia, isMessage, useRefHeaderPhone.current, isFooterMessage, isHeaderPreview]);

  function handleSearch(e) {
    delayedQuery(
      e
      .replace(/ /g, "_")
      .replace(/[^a-zA-Z0-9_]/g, "")
      .toLowerCase()
    );
  }
  
  const delayedQuery = async (q) => {
    setTemplate_name(q);
    clearTimeout(timer)
    
    const newTimer = setTimeout(async() => {
      onCheckTemplate(q)
    }, 500)
  
    setTimer(newTimer)
  }

  async function onCheckTemplate(ev) {
    if (ev) {
      await waTemplateSvc
        .getTemplateName(ev, isApplicatoinId[0])
        .then((result) => {
          if (result.data.data.available) {
            setErrorTemplateName(false);
          } else {
            setErrorTemplateName(true);
          }
        })
        .catch((error) => { });
    }
  }

  function PrevPage(val,index){
    // setChooseTypeTemplate(isChooseTypeTemplate)

    setIndexPage(index - 1)
    const choosedLang = isChooseTypeTemplate[index-1]
    setSelectedLanguage(choosedLang);
  }

  function nextPage(val,index){
    // setChooseTypeTemplate(isChooseTypeTemplate)

    setIndexPage(index + 1)
    const choosedLang = isChooseTypeTemplate[index+1]
    setSelectedLanguage(choosedLang);
  }

  const handleSelectAccount = (value) =>{
    if(value.value !== 'authentication'){
      addNewTemplate()
    }
    setSelectedAccount(value)
  }

  const inputTextHeader = useRef();
  function addVariableHeaderText(value, idx){
    let indexStart;
    let indexEnd;
    let val;
    let res;

    const el = inputTextHeader?.current;
    val = el?.value;
    indexStart = inputTextHeader?.current?.selectionStart;
    indexEnd = inputTextHeader?.current?.selectionEnd;
    res = value.substring(indexStart, indexEnd);
  
    isChooseTypeTemplate[idx].dataStructure.header[0].example = {}
    isChooseTypeTemplate[idx].dataStructure.header[0].example.header_text = []

    let chooseTemplate = isChooseTypeTemplate[idx].dataStructure.header[0]
    let currText = chooseTemplate.text


    const regexp = /([0-9]+)/gm

    const matched = currText.match(regexp)

    const addedText = `[${matched?.length > 0 ?  matched?.length + 1 : 1}]`
    currText += ` ${addedText} `

    chooseTemplate.text = currText

    const newMatched = currText.match(regexp)

    const matchVariable = chooseTemplate?.variable || []

    chooseTemplate.variable = newMatched?.length > 0 ? newMatched.map((item, idx) => {
      return {name: item, value: matchVariable[idx]?.value || ''}
    }) : []

    isChooseTypeTemplate[idx].dataStructure.header[0].text = currText;
    isChooseTypeTemplate[idx].dataStructure.header[0].example = {}
    isChooseTypeTemplate[idx].dataStructure.header[0].example.header_text = []

    // Trigger change value
    setHeaderPhone({ type: isHeaderPhone.type, text: data, body: data });
    
    setHeaderPreview({ type: isHeaderPhone.type, text: data, body: data })
  }

  const handleSelectLanguage = (value) =>{
    const tempFilter = isChooseTypeTemplate.filter((item) => item.value === value.value);
   
    if(tempFilter?.length === 0){
      const tempData = isChooseTypeTemplate;
      tempData.push(value)

      let dataStructure = tempData;
      dataStructure.forEach((item, index) =>{
        const dataS = {
          category: '',
          header: [{
            type: "HEADER",
            format: "NONE",
            text: '',
            example: {
              header_text: []
            }
          }],
          body:[ {
            type:"BODY",
            text: "",
            example: {
              body_text: [[]]
            }
          }],
          footer: [{
            type: "FOOTER",
            text: ""
          }],
          buttons: [{
                type: "BUTTONS",
                text: "",
                buttonType: '',
                url: "",
                example: [],
                buttons: [
                  {
                    type:'',
                    text: '',
                    phone_number: ''
                  }
                ]
              }],
          name: '',
          language: ''
        }
        if(value.value === item.value){
          return dataStructure[index].dataStructure = dataS;
        }
      })
     
      setChooseTypeTemplate(dataStructure);
      setSelectedLanguage(value)
      setSelectNewLanguage(value)
      
      setIndexPage(isChooseTypeTemplate?.length - 1)
    }
  }


  function handlesetOptionButtons(val, idx) {
    if(val.value === 'none'){
      isChooseTypeTemplate[idx].dataStructure.buttons[0].buttons = [];
      isChooseTypeTemplate[idx].dataStructure.buttons[0].buttonType = '';
     
      setOptionButtons(val);
      setPrefButton([]);
    }else if(
      val.value === 'visit_web' || 
      val.value === 'call_phone_number' || 
      val.value === 'copy_promo_code'){
      handleButtonTypeCTA(val, idx)
    }else if(
      val.value === "marketing_disapproval" ||
      val.value === "custom"){
      handleButtonTypeQR(val, idx);
    }
    setDropdownButtons(false);
  }

  const handleButtonTypeCTA = (val, idx) => {
    console.log('values cta',val,isChooseTypeTemplate[idx].dataStructure.buttons)
    isChooseTypeTemplate[idx].dataStructure.buttons.forEach((item, index) => {
      if(item.buttonType === "CTA"){
        if(val.value === 'visit_web'){
          isChooseTypeTemplate[idx].dataStructure.buttons[index].buttons.push({
            type: 'URL',
            text: '',
            websiteUrl: '',
            sampleUrl: '',
            typeCTA: {name: 'Visit Web', value: 'visit_web'},
            urlType: {name: 'Static', value: 'static'},
          })
          setTypeCTA({name:'Visit Web', value:'visit_web'})
        }else if(val.value === 'call_phone_number'){
          isChooseTypeTemplate[idx].dataStructure.buttons[index].buttons.push({
              type:'PHONE_NUMBER',
              text: '',
              typeCTA: {name: 'Call Phone Number', value: 'call_phone_number'},
              phone_number: '',
              // selectedPhoneNumber: {
              //   "name": "United States",
              //   "label": "US +1",
              //   "value": "US",
              //   "type": "+1"
              // }
          })
         
          setTypeCTA({name:'Call phone number', value:'call_phone_number'})
          
        }else if(val.value === 'copy_promo_code'){
          let chooseLanguage = dataFromLocation.language[0].value === "en" || dataFromLocation.language === 'en' ||
          dataFromLocation.language[0].value === "en_US" || dataFromLocation.language === 'en_US' || 
          dataFromLocation.language[0].value === "en_GB" || dataFromLocation.language === 'en_GB';
          isChooseTypeTemplate[idx].dataStructure.buttons[index].buttons.push({
            type: 'copy_promo_code',
            text: chooseLanguage ? 'Copy Promo Code' : 'Salin Kode Promo',
            websiteUrl: '',
            typeCTA: {name: 'Copy Promo Code', value: 'copy_promo_code'},
          })
          setTypeCTA({name:'Copy Promo Code', value:'copy_promo_code'})
        }
      }
    })

    setOptionButtons(val);
    setPrefButton([
      {
        type: "",
        index: 0,
        display: "",
        content: "",
        typeCTA: {name:'Call phone number', value:'call_phone_number'}
      },
    ]);
  }

  const handleButtonTypeQR = (val, idx) => {
    console.log('values cta',val)
    isChooseTypeTemplate[idx].dataStructure.buttons.forEach((item, index) => {
      if(item.buttonType === "QUICK_REPLY"){
        if(val.value === 'marketing_disapproval'){
          isChooseTypeTemplate[idx].dataStructure.buttons[index].buttons.push({
            type: "marketing_disapproval",
            text: '',
            typeCTA: {name: 'Marketing Disapproval', value: 'marketing_disapproval'},
            footer_marketing_disapproval: dataFromLocation.language[0].value === "en" || dataFromLocation.language === 'en' ? 'Not interested? Tap stop promotions' : "Hentikan promosi",
            term_condition: ''
          })
          setTypeCTA({name:'Marketing Disapproval', value:'marketing_disapproval'})
    
        }else{
          isChooseTypeTemplate[idx].dataStructure.buttons[index].buttons.push({
            type:'QUICK_REPLY',
            text: '',
            typeCTA: {name: 'Custom', value: 'custom'}
          })
          setTypeCTA({name:'Custom', value:'custom'})
        }
      }
    })
    setOptionButtons(val);
    setPrefButton([
      {
        type: "",
        index: 0,
        display: "",
        content: "",
        typeCTA: {name:'Custom', value:'custom'}
      },
    ]);
  }

  function handleDropdownType(val, idx, idxButton, index, button, isOptionButtons) {
    console.log('types', val, idx, index, button, isOptionButtons);
    if(button.buttonType === 'QUICK_REPLY'){
      if(val.value === 'custom'){
        isChooseTypeTemplate[idx].dataStructure.buttons[idxButton].action = val.value
        isChooseTypeTemplate[idx].dataStructure.buttons[idxButton].buttons[index].typeCTA = val
      }else{
        isChooseTypeTemplate[idx].dataStructure.buttons[idxButton].action = val.value
        isChooseTypeTemplate[idx].dataStructure.buttons[idxButton].footer_opt_out = ''
        isChooseTypeTemplate[idx].dataStructure.buttons[idxButton].buttons[index].typeCTA = val
        isChooseTypeTemplate[idx].dataStructure.buttons[idxButton].buttons[index].type = val.value
      }
    }

    if(button.buttonType === 'CTA'){
      if(val.value === 'call_phone_number'){
        isChooseTypeTemplate[idx].dataStructure.buttons[idxButton].action = 'phone_number'
        isChooseTypeTemplate[idx].dataStructure.buttons[idxButton].buttons[index].typeCTA = val
        // isChooseTypeTemplate[idx].dataStructure.buttons[idxButton].buttons[index].selectedPhoneNumber = {
        //   "name": "United States",
        //   "label": "US +1",
        //   "value": "US",
        //   "type": "+1"
        // }
        isChooseTypeTemplate[idx].dataStructure.buttons[idxButton].buttons[index].type = 'PHONE_NUMBER'
        
        // let countButton = button.buttons.filter((item) => item.typeCTA.value === "call_phone_number");
        // if(countButton.length === 1){
        //   isChooseTypeTemplate[idx].dataStructure.buttons[idxButton].buttons[index].disable = true;
        // }
      }else if(val.value === 'visit_web'){
        isChooseTypeTemplate[idx].dataStructure.buttons[idxButton].buttons[index].type = 'URL'
        isChooseTypeTemplate[idx].dataStructure.buttons[idxButton].action = val.value
        isChooseTypeTemplate[idx].dataStructure.buttons[idxButton].buttons[index].typeCTA = val
        isChooseTypeTemplate[idx].dataStructure.buttons[idxButton].buttons[index].urlType = {name: 'Static', value: 'static'}
        isChooseTypeTemplate[idx].dataStructure.buttons[idxButton].buttons[index].websiteUrl = ''
      
       
        // let countButton = button.buttons.filter((item) => item.typeCTA.value === "visit_web");
        // if(countButton.length === 1){
        //   isChooseTypeTemplate[idx].dataStructure.buttons[idxButton].buttons[index].disable = true;
        // }
      }else if(val.value === 'copy_promo_code'){
        let chooseLanguage = dataFromLocation.language[0].value === "en" || dataFromLocation.language === 'en' ||
          dataFromLocation.language[0].value === "en_US" || dataFromLocation.language === 'en_US' || 
          dataFromLocation.language[0].value === "en_GB" || dataFromLocation.language === 'en_GB';
          
        isChooseTypeTemplate[idx].dataStructure.buttons[idxButton].buttons[index].text = chooseLanguage ? 'Copy Promo Code' : 'Salin Kode Promo'
        isChooseTypeTemplate[idx].dataStructure.buttons[idxButton].buttons[index].action = val.value
        isChooseTypeTemplate[idx].dataStructure.buttons[idxButton].buttons[index].typeCTA = val
        isChooseTypeTemplate[idx].dataStructure.buttons[idxButton].buttons[index].copy_promo_code = ''
        isChooseTypeTemplate[idx].dataStructure.buttons[idxButton].buttons[index].type = val.value
        
        // let countButton = button.buttons.filter((item) => item.typeCTA.value === "copy_promo_code");
        // if(countButton.length === 1){
        //   isChooseTypeTemplate[idx].dataStructure.buttons[idxButton].buttons[index].disable = true;
        // }
        // console.log('countButton', countButton)
      }
    }

    if(button.buttonType === 'QUICK_REPLY'){
      setTypeQuickReply(val)
    }else{
      setTypeCTA(val)
    }

    let newData = [];
    newData.push(...isPrefButton);

    setPrefButton(newData);

    setPreview({
      header: isHeaderPhone,
      button: useRefButtons.current,
      footer: isFooterMessage,
      message: isMessage.trim(),
    });
    setDropdownButtons(false);
  }

  function handleDropdownUrlType(event, isOptionButtons) {
    isChooseTypeTemplate[event.idx].dataStructure.buttons[0].buttons[event.index].urlType = event.value
    isChooseTypeTemplate[event.idx].dataStructure.buttons[0].buttons[event.index].example = []

    setURLType({value:event.value.value, name:event.value.name})
    let newData = [];
    newData.push(...isPrefButton);

    setPrefButton(newData);

    setPreview({
      header: isHeaderPhone,
      button: useRefButtons.current,
      footer: isFooterMessage,
      message: isMessage.trim(),
    });
    setDropdownButtons(false);
  }

  function openRoomByLanguage(item, idx){
    setIndexPage(idx)
    setSelectedLanguage(item);
  }

  const isValidUrl = urlString=> {
    var urlPattern = new RegExp('^(https?:\\/\\/)?'+ // validate protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // validate domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // validate OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // validate port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?'+ // validate query string
    '(\\#[-a-z\\d_]*)?$','i'); // validate fragment locator
  return !!urlPattern.test(urlString);
}

  const checkLinkWebsite = (value) => {
    const domain = value.substring(value.lastIndexOf('.') + 1);
 
    if (!listDomain.includes(domain)) {
      return false;
    }
    if (listDomain.includes(domain)) {
      return true;
    }
    return domain;
  }

  function setChangeButtonOptions(event) {
    console.log('event types', event)
    if(event.action === 'marketing-opt-out'){
      isChooseTypeTemplate[event.idx].dataStructure.buttons[event.idxButton].buttons[event.index].footer_opt_out = event.footer_opt_out
      isChooseTypeTemplate[event.idx].dataStructure.buttons[event.idxButton].buttons[event.index].text = event.display
    }else if(event.action === 'custom'){
      isChooseTypeTemplate[event.idx].dataStructure.buttons[event.idxButton].buttons[event.index].text = event.display
    }else if(event.action === 'marketing_disapproval'){
      isChooseTypeTemplate[event.idx].dataStructure.buttons[event.idxButton].buttons[event.index].text = event.display
      isChooseTypeTemplate[event.idx].dataStructure.buttons[event.idxButton].buttons[event.index].footer_marketing_disapproval = event.footer_marketing_disapproval
      isChooseTypeTemplate[event.idx].dataStructure.buttons[event.idxButton].buttons[event.index].term_condition = event.term_condition
    }else if(event.action === 'copy_promo_code'){
      isChooseTypeTemplate[event.idx].dataStructure.buttons[event.idxButton].buttons[event.index].text = event.display
      isChooseTypeTemplate[event.idx].dataStructure.buttons[event.idxButton].buttons[event.index].copy_promo_code = event.copy_promo_code
    }else if(event.action === 'phone_number'){
      isChooseTypeTemplate[event.idx].dataStructure.buttons[event.idxButton].buttons[event.index].phone_number = event.phoneNumber
      isChooseTypeTemplate[event.idx].dataStructure.buttons[event.idxButton].buttons[event.index].text = event.display
    }else if(event.action === 'visit_web'){
      isChooseTypeTemplate[event.idx].dataStructure.buttons[event.idxButton].buttons[event.index].sampleUrl = event.sampleUrl
      isChooseTypeTemplate[event.idx].dataStructure.buttons[event.idxButton].buttons[event.index].text = event.display
      isChooseTypeTemplate[event.idx].dataStructure.buttons[event.idxButton].buttons[event.index].websiteUrl = event.websiteUrl

      const regexp = /([0-9]+)/gm

      const matched = event?.websiteUrl?.match(regexp);
      // console.log('matched', matched)
      
      if(
      // (isValidHttpUrl(event.websiteUrl) && checkLinkWebsite(event.websiteUrl)) || 
      (isValidHttpUrl(event.websiteUrl) && isValidUrl(event.websiteUrl) || matched?.length > 0)
      ){
        setErrorUrl(false)
      }else{
        setErrorUrl(true)
      }

    }
    let newData = [];
    newData.push(...isPrefButton);

    setPrefButton(newData);

    setPreview({
      header: isHeaderPhone,
      button: useRefButtons.current,
      footer: isFooterMessage,
      message: isMessage.trim(),
    });
  }


  function isValidHttpUrl(string) {
    let url;
    try {
      url = new URL(string);
    } catch (_) {
      return false;
    }
    return url.protocol === "http:" || url.protocol === "https:";
  }


  function handleOptionPhoneNumber(event, idx, index, button){
    // console.log('event', event)
    isChooseTypeTemplate[idx].dataStructure.buttons[0].buttons[index].selectedPhoneNumber = event;
    
    setPreview({
      header: isHeaderPhone,
      button: useRefButtons.current,
      footer: isFooterMessage,
      message: isMessage.trim(),
    });
  }

  function handleAddOtherButton(idx, type) {

    if(type === 'call_to_action'){
      if(isChooseTypeTemplate[idx]?.dataStructure?.buttons[0]?.buttons?.length < 1){
        
        isChooseTypeTemplate[idx].dataStructure.buttons[0].buttons.push(
          {
            type:'PHONE_NUMBER',
            text: '',
            typeCTA: {name: 'Call Phone Number', value: 'call_phone_number'},
            phone_number: '',
            selectedPhoneNumber: {
              "name": "United States",
              "label": "US +1",
              "value": "US",
              "type": "+1"
            }
          }
        )
        
        let newData = [];
        newData.push(...isPrefButton);
        newData.push({
          type: "",
          index: "",
          display: "",
          content: "",
        });
  
        setPrefButton(newData);
      }else{
        isChooseTypeTemplate[idx].dataStructure.buttons[0].buttons.forEach((item) =>{
          if(item.type === 'PHONE_NUMBER'){
            const endIndex = isChooseTypeTemplate[idx]?.dataStructure?.buttons[0]?.buttons[isChooseTypeTemplate[idx]?.dataStructure?.buttons[0]?.buttons?.length - 1]
            // console.log('endIndex', endIndex)
            if(!endIndex.text){
              setErrorButtonText(true);
            }else{
              setErrorButtonText(false);
              isChooseTypeTemplate[idx].dataStructure.buttons[0].buttons.push(
                {
                  type:'URL',
                  text: '',
                  typeCTA: {name: 'Visit Web', value: 'visit_web'},
                  urlType: {name: 'Static', value: 'static'},
                  websiteUrl: ''
                }
              )
            }
          }else{
            const endIndex = isChooseTypeTemplate[idx].dataStructure.buttons[0].buttons[isChooseTypeTemplate[idx].dataStructure.buttons[0].buttons.length - 1]
            if(!endIndex.text){
              setErrorButtonText(true);
            }else{
              setErrorButtonText(false);
              isChooseTypeTemplate[idx].dataStructure.buttons[0].buttons.push(
                {
                  type:'PHONE_NUMBER',
                  text: '',
                  typeCTA: {name: 'Call Phone Number', value: 'call_phone_number'},
                  phone_number: '',
                  selectedPhoneNumber: {
                    "name": "United States",
                    "label": "US +1",
                    "value": "US",
                    "type": "+1"
                  }
                }
              )
            }
          }
        })
      }
      let newData = [];
        newData.push(...isPrefButton);
        newData.push({
          type: "",
          index: "",
          display: "",
          content: "",
        });
  
        setPrefButton(newData);
    }

    if(type === 'quick_reply'){
      if(isChooseTypeTemplate[idx]?.dataStructure?.buttons[0]?.buttons?.length < 1){
        
        isChooseTypeTemplate[idx].dataStructure.buttons[0].buttons.push(
          {
            type:'QUICK_REPLY',
            text: '',
            typeCTA: {name: 'Custom', value: 'custom'}
          }
        )
        
        let newData = [];
        newData.push(...isPrefButton);
        newData.push({
          type: "",
          index: "",
          display: "",
          content: "",
        });
  
        setPrefButton(newData);
      }else{
        const endIndex = isChooseTypeTemplate[idx].dataStructure.buttons[0].buttons[isChooseTypeTemplate[idx].dataStructure.buttons[0].buttons.length - 1]
        if(!endIndex.text){
          setErrorButtonText(true);
        }else{
          setErrorButtonText(false);
          isChooseTypeTemplate[idx].dataStructure.buttons[0].buttons.push(
            {
              type:'QUICK_REPLY',
              text: '',
              typeCTA: {name: 'Custom', value: 'custom'}
            }
          )
        }

        let newData = [];
        newData.push(...isPrefButton);
        newData.push({
          type: "",
          index: "",
          display: "",
          content: "",
        });
  
        setPrefButton(newData);
      }
    }
  }

  const deleteTypeQuickReply = (idx, idxButton, index) => {
    let newData = [];
    newData.push(...isPrefButton);
    newData.splice(index, 1)
    setPrefButton(newData)

    isChooseTypeTemplate[idx].dataStructure.buttons[idxButton].buttons.splice(index,1);
  }


  function handleFooter(val) {
    isChooseTypeTemplate[val.idx].dataStructure.footer[0].text = val.text
    setFooterMessage(val)
  }

  let appIdRef = useRef();
  appIdRef.current = isApplicatoinId;

  const texAreaRef = useRef();

  let maxLengthTextArea = 1024;

  function handleAaddVariable(value, idx) {
    isChooseTypeTemplate[idx].dataStructure.body[0].example = {};
    isChooseTypeTemplate[idx].dataStructure.body[0].example.body_text = [];
    addVariable(texAreaRef, value, maxLengthTextArea, texAreaRef?.current?.selectionStart, idx);
  }

  function addVariable(template, value, length, indexStart, idx) {


    let chooseTemplate = isChooseTypeTemplate[idx].dataStructure.body[0]
    let currText = chooseTemplate.text


    const regexp = /([0-9]+)/gm

    const matched = currText.match(regexp)

    const addedText = `[${matched?.length > 0 ?  matched?.length + 1 : 1}]`
    currText += ` ${addedText} `

    chooseTemplate.text = currText

    const newMatched = currText.match(regexp)

    const matchVariable = chooseTemplate?.variable || []

    chooseTemplate.variable = newMatched?.length > 0 ? newMatched.map((item, idx) => {
      return {name: item, value: matchVariable[idx]?.value || ''}
    }) : []
    if(currText.length >= 1024) return;
    setBodyTemplate(currText);
  }

  function toggleEmojiPicker(value){
    setShowEmojiPicker(!showEmojiPicker)
  }

  function addEmoji(event, idx){
    const text = `${isBodyTemplate}${event.native}`;

    if(text.length >= 1024) return;
    setBodyMessage(text, idx)
    setShowEmojiPicker(false)
  }

  function handleInsertSymbol(symbol, idx) {
    let indexStart;
    let indexEnd;
    let val;
    let res;

    const el = texAreaRef?.current;
    val = el?.value;
    indexStart = texAreaRef?.current?.selectionStart;
    indexEnd = texAreaRef?.current?.selectionEnd;
    res = val.substring(indexStart, indexEnd);

    if (res) {
      let data = val.slice(0, indexStart) + symbol + res + symbol + val.slice(indexEnd);
      isChooseTypeTemplate[idx].dataStructure.body[0].text = val.slice(0, indexStart) + symbol + res + symbol + val.slice(indexEnd)
      setBodyTemplate(val.slice(0, indexStart) + symbol + res + symbol + val.slice(indexEnd));
    } else {
      let data =
        val.slice(0, indexStart) +
        " " +
        symbol +
        "fill-text" +
        symbol +
        " " +
        val.slice(indexStart);
      setBodyTemplate(
        val.slice(0, indexStart) + " " + symbol + symbol + " " + val.slice(indexStart)
      );
      isChooseTypeTemplate[idx].dataStructure.body[0].text = val.slice(0, indexStart) + " " + symbol + symbol + " " + val.slice(indexStart)
    }
  }

  function setBodyMessage(message, idx) {
    let brackets = false;
    let underscores = [];
    let newText = message;
    for (let i = 0; i < message.length; i++) {
      const char = newText[i];
      if (char === "[") {
        brackets = true;
      }
      if (newText[i] === "_" && brackets) {
        underscores.push(i);
      }
      if (newText[i] === "]") {
        brackets = false;
      }
    }

    underscores.reverse();
    // underscores.forEach((element) => {
    //   newText = setCharAt(newText, element, "&#95;");
    //   newText = setCharAt(newText, element, "_");
    // });

    let indexedMessage = []

    if(newText?.length >= 2){
      indexedMessage = [
        newText[newText?.length - 2],
        newText[newText?.length - 1],
      ]
    }

    const regexp = /([0-9]+)/gm

    const regexpDel = /([0-9])/gm

    const matched = newText.match(regexp)

    const newVariable = matched?.length > 0 ?  matched?.length + 1 : 1


    // ADD FUNCTION
    if(indexedMessage[0] == '{' && indexedMessage[1] == '{'){
      message += `${newVariable}}} `
      newText += `${newVariable}}} `
    }  


    // // DELETE FUNCTION
    if(indexedMessage[0]?.match(regexpDel) && indexedMessage[1] == ']'){
      message = message?.replace('['+indexedMessage[0]+']', '')
      newText = newText?.replace('['+indexedMessage[0]+']', '')
    }  

    isChooseTypeTemplate[idx].dataStructure.body[0].text = newText
    
    setBodyTemplate(newText);
    setMessage(newText);
  }

  function setNewTextOnBlur(message, idx){
    let brackets = false;
    let underscores = [];
    let newText = message;
    for (let i = 0; i < message.length; i++) {
      const char = newText[i];
      if (char === "[") {
        brackets = true;
      }
      if (newText[i] === "_" && brackets) {
        underscores.push(i);
      }
      if (newText[i] === "]") {
        brackets = false;
      }
    }

    underscores.reverse();
    // underscores.forEach((element) => {
    //   newText = setCharAt(newText, element, "&#95;");
    //   newText = setCharAt(newText, element, "_");
    // });

    const regexp = /([0-9]+)/gm

    const newMatched = newText.match(regexp)

    const matchVariable = isChooseTypeTemplate[idx].dataStructure.body[0].variable

    if(matchVariable){
      isChooseTypeTemplate[idx].dataStructure.body[0].variable = newMatched?.length > 0 ? newMatched.map((item, idx) => {
        return {name: matchVariable[idx]?.name || item, value: matchVariable[idx]?.value || ''}
      }) : []

      for(let i = 0; i < newMatched?.length; i++){
        const currName = isChooseTypeTemplate[idx].dataStructure.body[0].variable[i]?.name
        newText = newText.replace(newMatched[i], currName)
      }
    }
   

    if(isChooseTypeTemplate[idx]?.dataStructure?.body[0]?.example?.body_text){
      isChooseTypeTemplate[idx].dataStructure.body[0].example.body_text = isChooseTypeTemplate[idx].dataStructure.body[0].variable?.length ? isChooseTypeTemplate[idx].dataStructure.body[0].variable.map((variableBody) => variableBody?.value) : [] 
    }

    isChooseTypeTemplate[idx].dataStructure.body[0].text = newText

    setBodyTemplate(newText);
    setMessage(newText);
  }

  function setCharAt(str, index, chr) {
    if (index > str.length - 1) return str;
    return str.substring(0, index) + chr + str.substring(index + 1);
  }

  function handleSelectHeader(item, idx, headerValue){
    const structurHeaderText = {
        type: "HEADER",
        format: "TEXT",
        text: '',
        // example: {
        //   header_text: []
        // }
    }
    const structurHeaderMedia = {
        type: "HEADER",
        format: '',
        label: 'media',
        example: {
          header_handle: []
        }
    }
    const structurNone = {
        type: "HEADER",
        format: 'NONE',
        example: {
          header_handle: []
        }
    }

    let tempData = isChooseTypeTemplate[idx]?.dataStructure?.header.splice(0, 1);
    tempData = []
    if(item.value === 'TEXT'){
      tempData = structurHeaderText;
      isChooseTypeTemplate[idx]?.dataStructure?.header.push(structurHeaderText);
    }else if(item.value === 'MEDIA'){
      tempData =structurHeaderMedia;
      isChooseTypeTemplate[idx]?.dataStructure?.header.push(structurHeaderMedia);
    }else{
      tempData =structurNone;
      isChooseTypeTemplate[idx]?.dataStructure?.header.push(structurNone);
    }
    
    setHeaderPhone({ type: '', text: '', body: '' });
    setHeaderPreview({ type: '', text: '', body: '' })

    setOptionMedia(item);
  }

  function handleHeader(val) {
    if(val.type === 'text'){
      
      let indexedMessage = []

    if(val.text?.length >= 2){
      indexedMessage = [
        val.text[val.text?.length - 2],
        val.text[val.text?.length - 1],
      ]
    }

    const regexp = /{{([0-9]+)}}/gm

    const regexpDel = /([0-9])/gm

    const matched = val.text.match(regexp)

    const newVariable = matched?.length > 0 ?  matched?.length + 1 : 1

    // ADD FUNCTION
    if(indexedMessage[0] == '{' && indexedMessage[1] == '{'){
      val.text += `${newVariable}}} `
      val.text += `${newVariable}}} `
    }  


    // // DELETE FUNCTION
    if(indexedMessage[0]?.match(regexpDel) && indexedMessage[1] == '}'){
      val.text = val.text?.replace('{{'+indexedMessage[0]+'}', '')
      val.text = val.text?.replace('{{'+indexedMessage[0]+'}', '')
    }  

    isChooseTypeTemplate[val.idx].dataStructure.header[0].text = val.text
    isChooseTypeTemplate[val.idx].dataStructure.header[0].type = 'text'
    
    }else if(val.type === 'image'){
      isChooseTypeTemplate[val.idx].dataStructure.header[0].format = 'IMAGE';
      isChooseTypeTemplate[val.idx].dataStructure.header[0].type = 'image';
      isChooseTypeTemplate[val.idx].dataStructure.header[0].files = [];
    }else if(val.type === 'video'){
      isChooseTypeTemplate[val.idx].dataStructure.header[0].format = 'VIDEO'
      isChooseTypeTemplate[val.idx].dataStructure.header[0].type = 'video'
      isChooseTypeTemplate[val.idx].dataStructure.header[0].files = [];
    }else if(val.type === 'document'){
      isChooseTypeTemplate[val.idx].dataStructure.header[0].files = [];
      isChooseTypeTemplate[val.idx].dataStructure.header[0].format = 'DOCUMENT'
      isChooseTypeTemplate[val.idx].dataStructure.header[0].type = 'document'
    }

    setHeaderPreview({ type: '', text: '', body: '' })
    if (isOptionMedia.value == "media") {
      setHeaderPhone({ type: val.type, text: val.text, body: val.text });
      setHeaderPreview({type: val.type, text: val.text, body: val.text })
    }

    if (val.type === 'text') {
      setHeaderPhone({ type: val.type, text: val.text, body: val.text });
      setHeaderPreview({type: val.type, text: val.text, body: val.text })
      if(val.text.includes('{{1}}')){
        setDisableInputHeader(true)
      }else{
        setDisableInputHeader(false)
      }
    }

    if (isOptionMediaRef.current.value == "text") {
      if(val.text.includes('{{1}}')){
        setDisableInputHeader(true)
      }else{
        setDisableInputHeader(false)
      }
    } 
  }

  function setOnBlurHeaderText({text, idx}){
    let newText = text;

    const regexp = /{{([0-9]+)}}/gm

    const newMatched = newText.match(regexp)

    const matchVariable = isChooseTypeTemplate[idx].dataStructure.header[0].variable

    // console.log(newMatched, matchVariable, isChooseTypeTemplate[idx].dataStructure.header[0],'MATCH DATA HEADER')
    if(matchVariable){
      isChooseTypeTemplate[idx].dataStructure.header[0].variable = newMatched?.length > 0 ? newMatched.map((item, idx) => {
        return {name: matchVariable[idx]?.name || item, value: matchVariable[idx]?.value || ''}
      }) : []

      for(let i = 0; i < newMatched?.length; i++){
        const currName = isChooseTypeTemplate[idx].dataStructure.header[0].variable[i]?.name
        newText = newText.replace(newMatched[i], currName)
      }
    }


    if(isChooseTypeTemplate[idx]?.dataStructure?.header[0]?.example?.header_text){
      isChooseTypeTemplate[idx].dataStructure.header[0].example.header_text = isChooseTypeTemplate[idx].dataStructure.header[0].variable?.length ? isChooseTypeTemplate[idx].dataStructure.header[0].variable.map((variableBody) => variableBody?.value) : [] 
    }

    isChooseTypeTemplate[idx].dataStructure.header[0].text = newText

    setHeaderPreview({ type: '', text: '', body: '' })
  }

  function handleSampleContent(value){
    setHeaderPreview({ type: '', text: '', body: '', files: '' })
    if(value.sampleHeaderText){
      let indexStart;
      let indexEnd;
      let val;
      let res;
      let dataHeader
  
      const el = inputTextHeader?.current;
  
      if(el?.value.includes('{{1}}')){
        val = el?.value.replace('{{1}}', '')
      }
      indexStart = inputTextHeader?.current?.selectionStart;
      indexEnd = inputTextHeader?.current?.selectionEnd;
      res = value.sampleHeaderText.substring(indexStart, indexEnd);
      if(val){
        if(indexStart && indexEnd){
          dataHeader = val.slice(0, indexStart) + value.sampleHeaderText + res + val.slice(0, indexEnd);
        }else{
          dataHeader = val + value.sampleHeaderText + res;
        }
        setHeaderPreview({ type: isHeaderPreview.type, text: dataHeader, body: dataHeader })
      }
    }else if(value.files){
      let dataRes;
      let reader = new FileReader();
      reader.readAsDataURL(value.files);
      reader.onloadend = function(e) {
        dataRes = [reader.result];
        setHeaderPreview({ type: isHeaderPreview.type, text: '', body: [reader.result], files: [reader.result] })
      };
      reader.onerror = function(e) {
        // console.log('Error : ' + e.type);
      };
     
    }
  
  }

  const onSwitchSection = (idx) => {
    isChooseTypeTemplate[idx].dataStructure.buttons.reverse();
    setHeaderPreview({ type: '', text: '', body: '' })
  }

  function checkDisabledValidationButtonSubmit() {
    const tempDataBody = isChooseTypeTemplate[0]?.dataStructure?.body[0]?.text;
    const tempDataButton = isChooseTypeTemplate[0]?.dataStructure?.buttons;
    const dataSumButton = [...tempDataButton[0]?.buttons, ...tempDataButton[1]?.buttons];
    const maxButtonQR = dataSumButton.filter((item) => item.type == 'QUICK_REPLY');
    const maxButtonURL = dataSumButton.filter((item) => item.type == 'URL');
    const maxButtonPhoneNumber = dataSumButton.filter((item) => item.type == 'PHONE_NUMBER');
    // console.log('isChooseTypeTemplate', isChooseTypeTemplate[0]?.dataStructure, maxButtonQR);
    const lastIdxQR = maxButtonQR[maxButtonQR.length - 1];
    const lastIdxURL = maxButtonURL[maxButtonURL.length - 1];
    // console.log('lastIdxQR', lastIdxQR)
    // console.log('lastIdxURL', lastIdxURL)
    // console.log('maxButtonPhoneNumber', maxButtonPhoneNumber)
    const lastIdxPhoneNumber = maxButtonPhoneNumber[maxButtonPhoneNumber.length - 1];

    if(dataSumButton.length > 0) {
      if(
        maxButtonQR.length > 0 && !lastIdxQR.text ||
        maxButtonURL.length > 0 && !lastIdxURL.text ||
        maxButtonURL.length > 0 && !lastIdxURL.websiteUrl ||
        maxButtonPhoneNumber.length > 0 && !lastIdxPhoneNumber.text ||
        maxButtonPhoneNumber.length > 0 && !lastIdxPhoneNumber.phone_number
      ) {
        return true;
      } else {
        return false;
      }
    }    
    
    if(!tempDataBody) {
      return true;
    } else {
      return false;
    };
  }

  useEffect(()=>{
    if(isChooseTypeTemplate[0]?.dataStructure) {
      checkDisabledValidationButtonSubmit()
    }
  }, [isChooseTypeTemplate[0]?.dataStructure])


  // START INTEGRATION
  useEffect(()=>{
    getAllData();
  }, []);

  async function getAllData() {
    let res = await applicationSvc.getAll();

    if (res.data.data) {
      let data = [];
      res?.data?.data.forEach((element) => {
        data.push(element._id);
      });
      setApplicationId(data);
    }
  }

 
  // Submit form
  const _onSubmit = (status) =>{
    let isEdit = false;
    let templateID = '';
    if(dataFromLocation?.edit){
      isEdit = true;
      templateID = location?.state?.id
    }

    const reqBody = []
    isChooseTypeTemplate.category = isSelectedAccount.value;
    isChooseTypeTemplate.nameTemplate = isTemplate_name;
    const dataPayload = {}
    isChooseTypeTemplate.forEach((item) =>{
      dataPayload.template_category = _.upperCase(isSelectedAccount.value);
      dataPayload.language = item.value ? item.value : item.language;
      dataPayload.source = 'api';
      dataPayload.template_name = isTemplate_name;
      dataPayload.application_id = isApplicatoinId[0]
      // dataPayload.components = [];
      dataPayload.template_code_id = templateID;
    
      if(item.dataStructure.header[0].format !== 'NONE'){
        let header = {
          type: item.dataStructure.header[0].type,
          // format: item.dataStructure.header[0].format,
          // example: {}
        }
        if((item.dataStructure.header[0].format === 'IMAGE' && item.dataStructure.header[0].example?.header_handle?.length > 0) ||
          (item.dataStructure.header[0].format === 'VIDEO' && item.dataStructure.header[0].example?.header_handle?.length > 0) ||
          (item.dataStructure.header[0].format === 'DOCUMENT' && item.dataStructure.header[0].example?.header_handle?.length > 0)){
            header.example = {};
            header.example.header_handle = item.dataStructure.header[0].example.header_handle
        }else{
          if(item?.dataStructure?.header[0]?.example?.header_text?.length > 0 &&
            item?.dataStructure?.header[0]?.example?.header_text[0] !== ''){
            const isArray = Array.isArray(item.dataStructure.header[0]?.example?.header_text);
            if(isArray){
              header.example = {};
              header.example.header_text = item.dataStructure?.header[0]?.example?.header_text
            }else{
              header.example = {};
              header.example.header_text = [item.dataStructure?.header[0]?.example?.header_text]
            }
          }
        
          // header.text = {
          //   body: item.dataStructure.header[0].text
          // };

          if (header.type == "text") {
            header.text = {
              body: item.dataStructure.header[0].text
            };
          } else if(header.type === 'image'){
            header.image = {
              link : ''
            };
          }else if (header.type == "document") {
            header.image = {
              link : ''
            };
          } else if (header.type == "video") {
            header.video = {
              link : ''
            };
          }
        }
        dataPayload.header = header;
      }else{
        dataPayload.header = {
          type: 'none',
        }
        // dataPayload.header = {
        //   type: 'none',
        //   text: {
        //     body: ''
        //   }
        // }
      }

      if(item.dataStructure.body[0].text){
        let body = {
          type: item.dataStructure.body[0].type,
          text: item.dataStructure.body[0].text,
          // example: {
          //   body_text: []
          // }
        }
        if(item?.dataStructure?.body[0]?.example?.body_text[0]?.length>0 && item?.dataStructure?.body[0]?.example?.body_text !== undefined){
          const isArray = Array.isArray(item?.dataStructure?.body[0]?.example?.body_text[0]);
    
          if(isArray){
            body.example = {};
            body.example.body_text = item.dataStructure.body[0].example.body_text
          }else{
            body.example = {};
            body.example.body_text = [item.dataStructure.body[0].example.body_text]
          }
        }
        dataPayload.body = body.text;
      }

      if(item.dataStructure.footer[0].text){
        let footer = {
          type: item.dataStructure.footer[0].type === 'FOOTER' ? 'text' : 'text',
          text: {
            body: item.dataStructure.footer[0].text
          },
        }
        dataPayload.footer = footer;
      }else{
        dataPayload.footer = {
          type: 'none',
        }
        // dataPayload.footer = {
        //   type: 'none',
        //   text: {
        //     body: ''
        //   }
        // }
      }

      if(item.dataStructure.buttons.length>0){
        let reqButtons = []
        item.dataStructure.buttons.forEach((result, btnIndex) => {
          if(result.buttonType === 'QUICK_REPLY'){
            result.buttons.forEach((item, index) =>{
              if(item.type === "marketing_disapproval"){
                reqButtons.push({
                  type: item.type === 'QUICK_REPLY' ? 'quick_reply' : item.type,
                  text: item.text,
                  button_index: index,
                  order: btnIndex,
                  section: 'quick_reply',
                  button_info: {
                    button_text: item.text,
                    term_condition: item.term_condition,
                    footer_marketing_disapproval: item.footer_marketing_disapproval || ''
                  },
                })
              }else{
                reqButtons.push({
                  type: item.type === 'QUICK_REPLY' ? 'quick_reply' : item.type,
                  text: item.text,
                  button_index: index,
                  order: btnIndex,
                  section: 'quick_reply',
                  button_info: {
                    button_text: item.text,
                  },
                })
              }
            })
          }

          if(result.buttonType === 'CTA'){
            result.buttons.forEach((item, index) =>{
              if(item.type === 'PHONE_NUMBER'){
                reqButtons.push({
                  type: 'call_phone_number',
                  text: item.text,
                  phone_number: item.phone_number.replace(/\s/g, ''),
                  button_index: index,
                  order: btnIndex,
                  section: 'cta',
                  button_info: {
                    phone_number: item.phone_number.replace(/\s/g, ''),
                    button_text: item.text,
                    // type: item.selectedPhoneNumber.type,
                    value: item.phone_number.replace(/\s/g, '')
                  },
                })
              }else if(item.type === 'URL' || item.type === 'url' || item.type === 'url_dynamic'){
                let dataTemp = {
                  // type: 'url',
                  type: item?.urlType?.value === 'url_dynamic' ? 'url_dynamic' : 'url',
                  url_type: item?.urlType?.value === 'url_dynamic' ? 'url_dynamic' : 'url',
                  text: item.text,
                  url: item.websiteUrl,
                  button_index: index,
                  order: btnIndex,
                  section: 'cta',
                  button_info: {
                    button_text: item.text,
                    url: item.websiteUrl
                  }
                }

                if(item.sampleUrl){
                  dataTemp.sampleUrl = item.sampleUrl
                  dataTemp.button_info.sampleUrl = item.sampleUrl
                }

                // console.log('isArray', item?.dataStructure)
                if(item?.example?.length>0){
                  const regexp = /{{([0-9]+)}}/gm
  
                  const matched = dataTemp.url.match(regexp)
              
                  if(matched?.length > 0){
                    dataTemp.url = dataTemp.url + '/{{1}}'
                  }
                  dataTemp.example = item?.example;
                }
               
                reqButtons.push(dataTemp)
              }else{
                reqButtons.push({
                  type: item.type,
                  text: item.text,
                  button_index: index,
                  order: btnIndex,
                  section: 'cta',
                  button_info: {
                    button_text: item.text,
                    copy_promo_code: item.copy_promo_code
                  },
                })
              }
            })
          }
        })

        reqButtons.forEach((item, idx) => {
          item.button_index = idx;
          return item;
        });
        dataPayload.button = reqButtons
        reqBody.push(dataPayload);
      }
    })

    // setOpenModalSubmit({show:true, payload: reqBody, wabaID: isDataWabaID, isEdit: isEdit, templateID: templateID, isChooseTypeTemplate : isChooseTypeTemplate})
    // dataPayload.components.forEach((item) =>{
    //   if(item.type === 'HEADER'){
    //    return item;
    //   }

    //   if(item.type === 'BODY'){
    //     return item.text;
    //   }

    //   if(item.type === 'FOOTER'){
    //     return item;
    //   }

    //   if(item.type === 'BUTTONS'){
    //     let button = null;
    //     return  button = item.buttons;
    //   }
    // })

    // console.log('dataPayload',isChooseTypeTemplate[0].dataStructure.buttons, dataPayload)
    
    if (status == 'draft') {
      dataOnPost({ dataPost: dataPayload, status: status });
    } else if(status == 'save'){
      setOpenModal(true);
      setDataPost({ dataPost: dataPayload, status: status });
    }
  }

  async function dataOnPost(data) {
    // this.isLoading = true;
    let _id = location?.state?.id;

    if (dataFromLocation?.edit) {
      // UPDATE
      await waTemplateSvc
        .updateTemplate({ template_id: _id, status: data.status }, data.dataPost)
        .then((obj) => {
          if(obj.data.success){
            if (data.status == "draft") {
              Alert.showStatus(
                AlertType.SUCCESS,
                'Success!',
                'WhatsApp template successfully drafted.'
              )
            } else if (data.status == "save") {
              Alert.showStatus(
                AlertType.SUCCESS,
                'Success!',
                'WhatsApp template successfully created.'
              )
              setOpenModal(false);
            }
          }else{
            Alert.showStatus(
              'error',
              'Error',
              obj.data.errors.message
            )
          }
          setTimeout(() => {
            history.push("/new-whatsapp-template");
          }, 1500);
        })
        .catch((error) => {
          Alert.showStatus(
            'error',
            'Error',
            error?.message
          )
        });
    } else {
      // POST
      await waTemplateSvc
        .createTemplate(data.status, data.dataPost)
        .then((obj) => {
          if(obj.data.success){
            if (data.status == "draft") {
              Alert.showStatus(
                AlertType.SUCCESS,
                'Success!',
                'WhatsApp template successfully drafted.'
              )
            } else if (data.status == "save") {
              Alert.showStatus(
                AlertType.SUCCESS,
                'Success!',
                'WhatsApp template successfully created.'
              )
              setOpenModal(false);
            }
          }else{
            Alert.showStatus(
              'error',
              'Error',
              obj.data.errors.message
            )
          }
          setTimeout(() => {
            history.push("/new-whatsapp-template");
          }, 1500);
        })
        .catch((error) => {
          Alert.showStatus(
            'error',
            'Error',
            error?.message
          )
        });
    }
  }

  // END INTEGRATION

  if(!isChooseTypeTemplate) {
    return <div>Template not found</div>
  }

  if(isChooseTypeTemplate){
    return (
      <div>
        {
        isSelectedAccount.value !== '' && isSelectedAccount.value.toLowerCase() !== "authentication" 
        && (
          <div className='container_whatsapp h-100'>
            <Modal
              isOpen={isOpenModal}
              // onRequestClose={()=>setOpenModal(false)}
              style={customStyles}
              contentLabel="Example Modal"
            >
              <div className="modal-submit mb-2">
                <div className="title mb-2">Is the template you want to submit correct?</div>
                <div className="wording">
                  Make sure the template you submitted does not contain inappropriate or unlawful words in
                  Indonesia. For more details please read the Terms and Conditions of WhatsApp broadcast.
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-center mt-5">
                <div onClick={() => setOpenModal(false)} className="me-3 btn-secondary-template">
                  I'm not sure
                </div>
                <div onClick={() => dataOnPost(isDataPost)} className="btn-primary-template">
                  Yes, Submit
                </div>
              </div>
            </Modal>
            {/* //  <SampleContent 
            //   setSampleContentRef={setSampleContentRef}
            //   isAddSampleContent={isAddSampleContent} 
            //   showAddSampleContent={showAddSampleContent} 
            //   isPreview={isPreview} 
            //   handleSampleContent={handleSampleContent} 
            //   chooseData={isChooseTypeTemplate}
            // />  */}
            <ConfirmModalSubmit isOpenModal={isOpenModalSubmit} setOpenModal={setOpenModalSubmit}/>
            <div className='row d-flex align-items-center justify-content-between'>
              <div className='col-7'>
                <h3 className='fsize-24 title_custom_700'>
                  {dataFromLocation?.edit ? 'Edit Template' : 'Create Template'}
                </h3>
                <BreadCrumb dataBreadCrumb={isBreadcrumb} className="mb-4" />
              </div>
              <div className='col-5'>
                <div className='d-flex align-items-center justify-content-end'>
                  <div className='me-3 d-none'>
                    <ButtonSecondary 
                      handleRoute={()=>showAddSampleContent({show: true, isIndexPage: isIndexPage})}
                      backgroundColor="#FFFFFF"
                      textColor="#312F30"
                      padding=".360rem 1rem"
                    >
                      Add Sample
                    </ButtonSecondary>
                  </div>
                  <div className='me-3'>
                    <ButtonSecondary 
                      handleRoute={()=>_onSubmit('draft')}
                      backgroundColor="#FFFFFF"
                      textColor="#312F30"
                      padding=".360rem 1rem"
                      disabled={checkDisabledValidationButtonSubmit()}
                    >
                      Save as Draft
                    </ButtonSecondary>
                  </div>
                  <div>
                    <ButtonV2 
                      handleRoute={()=>_onSubmit('save')}
                      backgroundColor="#3B3B47"
                      textColor="#FFFFFF"
                      padding=".360rem 1rem"
                      disabled={checkDisabledValidationButtonSubmit()}
                    >
                        Submit
                    </ButtonV2>
                  </div>
                </div>
              </div>

            </div>
            <div className='wrapper_content_form'>
              <div className='header d-flex flex-column w-100'>
                <div className='d-flex align-items-center w-100'>

                  {/* Template name */}
                  <div className='d-flex align-items-center'>
                    <label className='fsize-14 fweight-500 cl-weight-grey d-block me-3'>
                      Template Name
                    </label>
                    <div>
                      <div className='template_name_input'>
                        <input 
                          value={isTemplate_name}
                          onChange={(e) => handleSearch(e.target.value)}
                          type='text' 
                          className={`${dataFromLocation?.edit && 'event_disable'}cl-neutral500 fsize-14 fweight-400 form-control`}
                          placeholder='Template Name...' 
                          maxLength={512}
                        />
                        <span className='template_length fsize-12 cl-dark-grey fweight-400'>{isTemplate_name.length} / 512</span>
                      </div>
                      {isErrorTemplateName && 
                      <span className="cl-red fsize-12 fweight-400 mt-1">
                        Template name is already used. Please use other template name!
                      </span>
                      }
                    </div>
                  </div>
                  <div className='border_height mx-3'></div>
                  {/* Type Template / Category */}
                  {dataFromLocation?.edit && 
                  <div className='wrapp_category d-flex align-items-center'>
                    <div className='fsize-14 fweight-500 cl-neutral400 d-flex align-items-center justify-content-between'>
                      <label className='fsize-14 fweight-500 cl-weight-grey d-block me-2'>Category </label>
                      {/* <div className='ms-1'>
                        {_.startCase(isSelectedAccount.name)}
                      </div> */}
                      <div>
                        <DropdownV3 
                          className="ms-1 event_disable"
                          isListSearch={isListAccount} 
                          setSelectedSearch={handleSelectAccount} 
                          isSelected={isSelectedAccount}
                          placeholder="Select Account"
                        />
                      </div>
                    </div>
                    <div className='border_height  ms-4 me-2'></div>
                    <div className={`${
                      dataFromLocation?.status === 'InReview' ? 'InReview' : 
                      dataFromLocation?.status === 'IN_APPEAL' ? 'InReview' : 
                      dataFromLocation?.status === 'Requested' ? 'requested' : 
                      dataFromLocation?.status === 'DISABLED' ? 'requested' : 
                      dataFromLocation?.status === 'Active' ? 'active-high' : 
                      dataFromLocation?.status === 'REJECTED' ? 'rejected' : 
                      dataFromLocation?.status === 'active-low' ? 'active-low' : 
                      dataFromLocation?.status === 'PAUSED' ? 'paused' : 
                      dataFromLocation?.status === 'PENDING' ? 'pending' : 
                      dataFromLocation?.status === 'APPROVED' ? 'active-high' : 
                      dataFromLocation?.status === 'Draft' ? 'pending' : 
                      ''
                    } fweight-600 fsize-12 ms-2`}>
                      {_.startCase(dataFromLocation?.status)}
                    </div>
                    <div className='border_height  ms-4 me-2'></div>
                  </div>
                  }

                  {!dataFromLocation?.edit && 
                    <div className='fsize-14 fweight-500 cl-neutral400 d-flex align-items-center justify-content-between'>
                      <label className='fsize-14 fweight-500 cl-weight-grey d-block me-2'>Category </label>
                      <div>
                        <DropdownV3 
                          className="ms-2"
                          isListSearch={isListAccount} 
                          setSelectedSearch={handleSelectAccount} 
                          isSelected={isSelectedAccount}
                          placeholder="Select Account"
                        />
                      </div>
                      <div className='border_height ms-4 me-2'></div>
                    </div>
                  }

                  {/* Language */}
                  <div className='d-flex align-items-center wrapp_language px-2'>
                    <span className='elipsis me-2'></span>
                    <span className='fsize-14 fweight-500 cl-neutral400'>{_.startCase(isSelectedLanguage?.name)}</span>
                  </div>
                </div>
                {isSelectedAccount.value !== 'authentication' &&
                  <BadgeInfo></BadgeInfo>
                }
              </div>
              <ContentTemplate 
                isChooseTypeTemplate={isChooseTypeTemplate}
                isIndexPage={isIndexPage}
                isPreview={isPreview}
                location={location}
                handleSelectLanguage={handleSelectLanguage}
                isSelectNewLanguage={isSelectNewLanguage}
                handleSelectHeader={handleSelectHeader}
                isOptionMedia={isOptionMedia}
                handleHeader={handleHeader}
                setOnBlurHeaderText={setOnBlurHeaderText}
                addVariableHeaderText={addVariableHeaderText}
                isDisableInputHeader={isDisableInputHeader}
                setBodyMessage={setBodyMessage}
                setNewTextOnBlur={setNewTextOnBlur}
                addEmoji={addEmoji}
                handleInsertSymbol={handleInsertSymbol}
                isCountVariable={isCountVariable}
                handleAaddVariable={handleAaddVariable}
                handleFooter={handleFooter}
                isSelectedLanguage={isSelectedLanguage}
                texAreaRef={texAreaRef}
                toggleEmojiPicker={toggleEmojiPicker}
                showEmojiPicker={showEmojiPicker} 
                isFooterMessage={isFooterMessage}
                handlesetOptionButtons={handlesetOptionButtons}
                handleDropdownType={handleDropdownType}
                setChangeButtonOptions={setChangeButtonOptions} 
                deleteTypeQuickReply={deleteTypeQuickReply} 
                handleAddOtherButton={handleAddOtherButton}
                handleOptionPhoneNumber={handleOptionPhoneNumber}
                handleDropdownUrlType={handleDropdownUrlType}
                isHeaderPhone={isHeaderPhone}
                inputTextHeader={inputTextHeader}
                isErrorButtonText={isErrorButtonText}
                listPhoneNumber={listPhoneNumber}
                isOptionPhoneNumber={isOptionPhoneNumber}
                isErrorUrl={isErrorUrl}
                isOptionButtons={isOptionButtons}
                isVarDynamicWeb={isVarDynamicWeb}
                onSwitchSection={onSwitchSection}
                setHeaderPreview={setHeaderPreview}
                isSelectedAccount={isSelectedAccount}
              />
            </div>
          </div>
        )}
        {
        isSelectedAccount.value !== '' && isSelectedAccount.value.toLowerCase() === "authentication"
        && (
          <FormAuthentication 
            isDataForAuthentication={isDataForAuthentication} 
            handleSelectAccount={handleSelectAccount}  
            selectedAccountTemplate={isSelectedAccount}
            />
        )}
      </div>
    )
  }
}

export default FormCreateTeamplate